// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/account-rent-points-create/account-rent-points-create.css
// module id = 85
// module chunks = 0